var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageCropMask = function SvgImageCropMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 407 407",
    style: {
      enableBackground: "new 0 0 407 407"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.5 0H0v407h407V0H203.5Zm0 0C315.89 0 407 91.11 407 203.5S315.89 407 203.5 407 0 315.89 0 203.5 91.11 0 203.5 0Z",
    fill: "#000",
    fillOpacity: 0.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 203.5,
    r: 202.5,
    stroke: "#fff",
    strokeWidth: 2,
    fill: "none"
  })));
};
export default SvgImageCropMask;